import React from "react";
import { useLanguage } from "../../i18n/LanguageContext";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";

export default function CaseFilesNotSavedDialog({ open, onConfirm }) {
  const { t } = useLanguage();
  return (
    <AlertDialog open={open} onOpenChange={() => {}}>
      <AlertDialogContent
        data-testid="history-files-not-saved"
        onEscapeKeyDown={(event) => event.preventDefault()}
        onPointerDownOutside={(event) => event.preventDefault()}
      >
        <AlertDialogHeader>
          <AlertDialogTitle>{t("history.caseFilesNotSavedTitle")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("history.caseFilesNotSaved")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction
            data-testid="history-files-not-saved-ok"
            onClick={onConfirm}
          >
            {t("history.caseFilesNotSavedOk")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
